export default function ComparisonTable() {
  const rows = [
    { aspect: 'Стоимость', internal: 'Ниже на старте', external: 'Окупается результатом', internalIcon: 'ri-money-dollar-circle-line', externalIcon: 'ri-funds-line' },
    { aspect: 'Взгляд на бизнес', internal: 'Знают внутренние процессы', external: 'Независимый свежий взгляд', internalIcon: 'ri-building-line', externalIcon: 'ri-eye-line' },
    { aspect: 'Экспертиза', internal: 'Ограничена опытом компании', external: 'Лучшие практики рынка', internalIcon: 'ri-book-2-line', externalIcon: 'ri-global-line' },
    { aspect: 'Новые идеи', internal: 'Редко — варятся в своём соку', external: 'Постоянно — кросс-отраслевой опыт', internalIcon: 'ri-lightbulb-flash-line', externalIcon: 'ri-rocket-line' },
    { aspect: 'Вовлечённость', internal: 'Сложнее — привыкли к внутреннему спикеру', external: 'Выше — эффект приглашённого эксперта', internalIcon: 'ri-user-line', externalIcon: 'ri-user-star-line' },
    { aspect: 'Гибкость программы', internal: 'Часто шаблонная', external: 'Адаптируется под бизнес-задачи', internalIcon: 'ri-file-copy-line', externalIcon: 'ri-tools-line' },
    { aspect: 'Измеримость', internal: 'Не всегда есть метрики', external: 'Чёткие KPI и отчётность', internalIcon: 'ri-question-line', externalIcon: 'ri-check-double-line' },
    { aspect: 'Долгосрочный эффект', internal: 'Зависит от мотивации', external: 'Сопровождение и поддержка', internalIcon: 'ri-calendar-line', externalIcon: 'ri-repeat-line' },
  ];

  return (
    <section id="comparison" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-4">
          Внутреннее vs Внешнее обучение
        </h2>
        <p className="text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto">
          Сравнение двух подходов к развитию персонала — какой выбрать для вашего бизнеса
        </p>

        {/* Desktop table */}
        <div className="hidden md:block overflow-hidden rounded-2xl border border-gray-200">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-teal-600 text-white">
                <th className="p-5 text-left text-sm font-semibold w-1/4">Критерий</th>
                <th className="p-5 text-left text-sm font-semibold w-[37.5%]">
                  <div className="flex items-center gap-2">
                    <i className="ri-building-line"></i>
                    Внутреннее обучение
                  </div>
                </th>
                <th className="p-5 text-left text-sm font-semibold w-[37.5%]">
                  <div className="flex items-center gap-2">
                    <i className="ri-global-line"></i>
                    Внешнее обучение (BusinessTraining.by)
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className={`border-b border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/70'} hover:bg-teal-50/50 transition-colors`}>
                  <td className="p-5 text-sm font-semibold text-gray-900">{row.aspect}</td>
                  <td className="p-5 text-sm text-gray-600">{row.internal}</td>
                  <td className="p-5 text-sm text-gray-900 font-medium">{row.external}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile cards */}
        <div className="md:hidden space-y-4">
          {rows.map((row, i) => (
            <div key={i} className="bg-white rounded-xl p-5 border border-gray-100">
              <h3 className="text-sm font-bold text-gray-900 mb-3">{row.aspect}</h3>
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-gray-50 p-3 rounded-lg">
                  <div className="flex items-center gap-1.5 mb-1">
                    <i className="ri-building-line text-xs text-gray-400"></i>
                    <span className="text-[10px] font-semibold text-gray-500 uppercase">Внутреннее</span>
                  </div>
                  <p className="text-xs text-gray-600">{row.internal}</p>
                </div>
                <div className="bg-teal-50 p-3 rounded-lg">
                  <div className="flex items-center gap-1.5 mb-1">
                    <i className="ri-global-line text-xs text-teal-500"></i>
                    <span className="text-[10px] font-semibold text-teal-600 uppercase">Внешнее</span>
                  </div>
                  <p className="text-xs text-teal-900 font-medium">{row.external}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto mt-12 bg-teal-600 text-white rounded-xl p-8 text-center">
          <p className="text-lg md:text-xl font-semibold leading-relaxed">
            Внешнее обучение даёт независимую экспертизу, свежий взгляд и лучшие практики рынка. Именно такой подход обеспечивает максимальную эффективность корпоративного обучения.
          </p>
        </div>
      </div>
    </section>
  );
}